/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	AnalyticsWhatsAppCampaignAnalyticsPathParams,
	AnalyticsWhatsAppCampaignAnalyticsQueryParams,
	AnalyticsWhatsAppCampaignAnalyticsResponse,
} from '../types/AnalyticsWhatsAppCampaignAnalytics'

/**
 * GET /campaigns/:campaign/whatsapp-analytics
 * @see backend/nexus/modules/Analytics/Http/Controllers/AnalyticsController.php AnalyticsController::whatsAppCampaignAnalytics
 */
export async function analyticsWhatsAppCampaignAnalytics(
	campaign: AnalyticsWhatsAppCampaignAnalyticsPathParams['campaign'],
	params?: AnalyticsWhatsAppCampaignAnalyticsQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AnalyticsWhatsAppCampaignAnalyticsResponse>> {
	return axiosInstance.get(`/campaigns/${campaign}/whatsapp-analytics`, { params, ...config })
}
